export const LIMIT_RECORDS_FOR_PRINT = 500;
export const PAGE_LIMIT = 100;
export const SPACE_KEY_CODE = 'Space';

export const EXCLUDE_FOR_EXPORT = [
  'selector',
  'possibleActions',
  'actions',
  'id',
  'subRowControl'
];

export const EXCLUDE_FOR_PRINT = ['selector', 'possibleActions', 'actions', 'id'];

export const EXTRA_PRINT_PROPS = {
  bulkActionsShown: false,
  FooterComponent: null,
  showSavedViews: false
};

export const LAYOUT_KEYS = {
  autoHeight: 'autoHeight',
  print: 'print'
};

export const FLITER_VALUE_GRANULARITY = '0.01';

export const GRID_STATE_PARAM_NAMES = {
  filters: 'filters',
  page: 'page',
  pageSize: 'pageSize',
  savedViews: 'savedViews',
  sort: 'sort'
};

export const GRID_STATE_PARAM_TYPES = {
  FETCH: 'FETCH'
};

export const GRID_CELL_RENDERER = {
  ACTIONS: 'actions'
};
